import { unwrapResult } from '@reduxjs/toolkit';
import { logError } from '@ff-os/shared-utils/logging';
import { fireOrderEventToSite } from '../global-state/site-events';
import { PdpThunk } from '../store';
import { pushProject } from './projects/pushProject';

export const submitOrder = (quantity: number = 1): PdpThunk => {
    return async (dispatch, getState) => {
        try {

            const result = unwrapResult(await dispatch(pushProject()));
            const state = getState();

            return await fireOrderEventToSite({
                name: 'order',
                quantity: quantity,
                projectId: state.auth.secret!,
                snapshotId: result.snapshotId
            });

        } catch (e) {
            logError(e);
        }
    };
};